import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CalendarView from './CalendarView';
import JobSchedulingDashboard from './JobSchedulingDashboard';

const JobsDashboard = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('scheduling');

  // Simple tab button component
  const TabButton = ({ value, label, current, onClick }) => (
    <button
      className={`px-2 py-1 text-xs font-medium rounded-t-md ${
        value === current
          ? 'bg-gray-800 text-blue-400 border-b-2 border-blue-500'
          : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
      }`}
      onClick={() => onClick(value)}
    >
      {label}
    </button>
  );

  return (
    <div className="h-full bg-gray-900">
      {/* Tabs at the very top */}
      <div className="flex space-x-1 mb-2 border-b border-gray-700">
        <TabButton 
          value="scheduling" 
          label={t('jobs.jobScheduling')} 
          current={activeTab} 
          onClick={setActiveTab}
        />
        <TabButton 
          value="calendar" 
          label={t('jobs.calendarView')} 
          current={activeTab} 
          onClick={setActiveTab}
        />
      </div>

      {/* Main Content */}
      <div className="bg-gray-900">
        {activeTab === 'scheduling' && <JobSchedulingDashboard />}
        {activeTab === 'calendar' && <CalendarView />}
      </div>
    </div>
  );
};

export default JobsDashboard; 